import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import Item from '../../../../../models/Item';
import FormFeedback from '../../../../common/form/FormFeedback';
import CategoryPicker from './CategoryPicker';
import ItemDrillDown from './ItemDrillDown';


function isNonStockCategory(category) {
  switch (category) {
    case 'CAR':
    case 'COMIC':
    case 'WATCH':
      return false;

    default:
      return true;
  }
}

class NewItemWizardForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
    };
  }


  onChangeStep = (nextStep, category) => {
    if (category && isNonStockCategory(category)) {
      const { onPickItem } = this.props;
      onPickItem({}, category);
    } else {
      this.setState({ step: nextStep });
    }
  };

  renderForm = (formProps) => {
    const {
      values,
      // errors,
      // touched,
      // handleChange,
      // handleBlur,
      status,
      // handleSubmit,
      setFieldValue,
    } = formProps;
    const { step } = this.state;
    const { onPickItem, isWriting, addItemStatus } = this.props;

    return (
      <Form>
        <FormFeedback status={status} />
        <FormFeedback status={addItemStatus} />

        {step === 1 ? <CategoryPicker nextHandler={this.onChangeStep} values={values} isWriting={isWriting} /> : null}

        {step === 2 ? (
          <ItemDrillDown
            type={values.category}
            formValueSetter={setFieldValue}
            onChangeStep={this.onChangeStep}
            onPickItem={onPickItem}
            isWriting={isWriting}
          />
        ) : null}
      </Form>
    );
  };

  render() {
    return (
      <div className="newItemWizardForm columns is-centered">
        <div className="column">
          <Formik initialValues={new Item()} render={this.renderForm} onSubmit={() => {}} />
        </div>
      </div>
    );
  }
}

NewItemWizardForm.propTypes = {
  onPickItem: PropTypes.func.isRequired,
  isWriting: PropTypes.func.isRequired,
  addItemStatus: PropTypes.element.isRequired,
};

export default NewItemWizardForm;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/addForms/NewItemWizardForm.jsx